// Auto-generated guest profile. First-time visitors land directly on the
// main menu with a "Guest 1234"-style name and a random colourful avatar —
// they can play immediately and decide later whether to create a real
// account or sign in with a code.
//
// Guest profiles are distinguished from "real" accounts purely by the
// absence of a `code` field on the LocalProfile.

import type { AvatarConfig, HatId, PatternId } from "@shared/types";
import { createProfile, type LocalProfile } from "./profile";

const SHIRT_COLORS = [
  "#ff5fa7", "#ffd166", "#6bd0ff", "#7c3aed", "#34d399",
  "#fb7185", "#f97316", "#a855f7", "#22d3ee", "#facc15",
];
const SKIN_COLORS = ["#f6c89f", "#e0a26c", "#c98554", "#a96334", "#7a4823"];
const PANTS_COLORS = ["#312e81", "#0f172a", "#4c1d95", "#1e3a8a", "#064e3b"];
const HATS: HatId[] = ["none", "cap-blue", "cap-red", "beanie", "crown", "party-hat", "headband"];
const PATTERNS: PatternId[] = ["solid", "stripes", "dots", "star", "zigzag", "lightning"];

function pick<T>(arr: readonly T[]): T {
  return arr[Math.floor(Math.random() * arr.length)]!;
}

export function randomGuestName(): string {
  // Four-digit suffix, padded for consistent visual width.
  const n = Math.floor(1000 + Math.random() * 9000);
  return `Guest ${n}`;
}

export function randomGuestAvatar(): AvatarConfig {
  return {
    shirtColor: pick(SHIRT_COLORS),
    skinColor: pick(SKIN_COLORS),
    pantsColor: pick(PANTS_COLORS),
    hatId: pick(HATS),
    patternId: pick(PATTERNS),
  };
}

/** Create a fresh guest profile and persist it to localStorage. */
export function createGuestProfile(): LocalProfile {
  return createProfile(randomGuestName(), randomGuestAvatar(), "en");
}

/** A profile is a guest if it doesn't have a server-issued account code. */
export function isGuest(profile: LocalProfile | null): boolean {
  return !!profile && !profile.code;
}
